import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

export function ErrorFallback({ error, resetErrorBoundary }: any) {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#fafafa",
                p: 3,
            }}
        >
            <Box
                sx={{
                    maxWidth: 420,
                    width: "100%",
                    textAlign: "center",
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    p: 4,
                    bgcolor: "white",
                }}
            >
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 400 }}>
                    Something went wrong
                </Typography>

                <Typography
                    sx={{
                        color: "#666",
                        fontSize: "14px",
                        whiteSpace: "pre-wrap",
                        mb: 3,
                        fontWeight: 300,
                    }}
                >
                    {error?.message || "Unknown error"}
                </Typography>

                <Stack direction="column" spacing={1}>
                    <Button
                        variant="contained"
                        onClick={resetErrorBoundary}
                        sx={{ textTransform: "none", borderRadius: 1 }}
                    >
                        Try Again
                    </Button>

                    <Button
                        variant="text"
                        color="secondary"
                        startIcon={<HomeIcon />}
                        onClick={() => {
                            window.location.href = "/";
                        }}
                        sx={{
                            textTransform: "none",
                            borderRadius: 1,
                            fontWeight: 400,
                        }}
                    >
                        Go to Home
                    </Button>
                </Stack>
            </Box>
        </Box>
    );
}
